import type { DalError, DalReturn } from "@/core/dal/data.type";
import { dalDbOperation } from "@/core/dal/helper";
import type { ContactFormData } from "@/core/schemas/contact.form.schema";
import type ApiService from "@/core/services/api.service";
import type APIEndpointsService from "@/core/services/api-endpoints.service";

class ContactsService {
  constructor(
    private apiService: ApiService,
    private apiEndpointsService: APIEndpointsService
  ) {}

  submitContact(data: ContactFormData): Promise<DalReturn<void, DalError>> {
    return dalDbOperation(async () => {
      await this.apiService.post(
        this.apiEndpointsService.getRoutes().contacts.post(),
        data
      );
    });
  }
}

export default ContactsService;
